import { StatusBar } from 'expo-status-bar';
import React from 'react';
import PropTypes from 'prop-types'
import ENV from 'app/utils/ENV'
import { StyleSheet, View, ScrollView, TouchableOpacity, 
  TouchableWithoutFeedback, Platform, TextInput, Dimensions, Animated, } from 'react-native';
import { styleSheet, colors, sizes, screenRatio, WIDTH, HEIGHT, } from 'app/utils/styleSheet'
import { Hoverable } from 'react-native-web-hooks';
import { Ionicons } from '@expo/vector-icons';

import apiActions from 'app/utils/apiActions'
import valueActions from 'app/utils/valueActions'
import prefActions from 'app/utils/prefActions'
import storageActions from 'app/utils/storageActions'
import * as RootNavigation from 'app/utils/RootNavigation.js';
import textHelpers from 'app/utils/textHelpers'
import valueHelpers from 'app/utils/valueHelpers'
import filterHelpers from 'app/utils/filterHelpers'

import FilterBar from 'app/components/FilterBar'
import Text from 'app/components/Text'
import Value from 'app/components/Value'
import Wheel from 'app/components/Wheel'

import store from 'app/redux/store'

export default class Grears extends React.Component {
  
  static navigationOptions = ({ navigation, navigationOptions, screenProps}) => {
    return {headerShown: false}
  };

  constructor(props) {
    super(props);
    let { values, app } = store.getState()
    let levelIds = valueHelpers.getLevelIds(values)
    values = valueHelpers.filterToCurrentRevisions(values)
    values = valueHelpers.sortByProgress(values, levelIds)
    let topLevel = valueHelpers.getTopLevel(levelIds)
    console.log(topLevel, valueHelpers.getLevelIds(values,true))
    this.state = {
      values,
      levelIds,
      topLevel,
      loading: app.loading,
      fetching: false,
      query: '',
      hideComplete: true,
      fromBottom: true,
      familyIds: [],
      selectedValue: null,
      quickActionsId: null,
      enableBlur: true,
      redrawKey: 0,
      consellationKey: 0,
      scrollHeight: Dimensions.get('window').height,
      scrollHeight: null,
      hiddenIds: [],
      filters: [],
      todoIds: [],
      focusIds: [],
      prefsLoaded: false,
      lastPressedId: null,
      xOffset: 0,
      applyScaling: false,
    }
  }

  setHeaderButton = () => {
    let { navigation, route, } = this.props
    navigation.setOptions({
      headerRight: () => (
        <TouchableOpacity onPress={navigation.toggleDrawer}>
          <Ionicons name="ios-menu" size={32} color={colors.foreground} style={{marginRight: 20}} />
        </TouchableOpacity>
      ),
    })
  }

  async componentDidMount(){
    this.setHeaderButton()
    
    this.unsubscribe = store.subscribe(() => {
      // console.log('updating from store')
      let { values, app, } = store.getState()
      let { loading, } = app
      values = filterHelpers.apply(values)
      values = valueHelpers.filterToCurrentRevisions(values)

      let levelIds = valueHelpers.getLevelIds(values)
      let topLevel = valueHelpers.getTopLevel(levelIds)
      values = valueHelpers.sortByProgress(values, levelIds)
      
      this.setState({values, levelIds, topLevel, loading})
    })
  }

  componentWillUnmount() {
    this.unsubscribe();
  }

  render(){
    let { values, fetching, query,
      hideComplete, fromBottom,
      familyIds, selectedValue, quickActionsId, enableBlur, redrawKey, scrollHeight,
      filters, loading,
      showFocus,
      applyScaling,
    } = this.state

    return (
      <View style={styles.container} key={redrawKey}>
        <StatusBar style="auto" />

        <FilterBar />

        <View style={styles.headerRow}>
          <Text button selectedButton={applyScaling}
            onPress={() => this.setState({applyScaling: !applyScaling})}
          >
            Scale
          </Text>
        </View>

        <View style={{flex: 1, zIndex: 1}}>
          {!loading && this.renderLevels()}
        </View>
        
        <View />
      </View>
    );
  }

  renderLevels = () => {
    let { values, levelIds, topLevel, fetching, query, fromBottom,
      familyIds, selectedValue, quickActionsId, enableBlur, consellationKey,
      showFocus, filterKey, applyScaling,
    } = this.state

    let SIZE = SIZE_CONST
    // if(applyScaling) SIZE = Math.max(WIDTH, HEIGHT)

    return (
      <View style={{flex: 1, overflow: 'hidden',}}>

        <TouchableWithoutFeedback
          onPress={() => {
            this.hoverOut()
            this.setState({quickActionsId: null})
            this.resetRotations()
          }}
        >
          <View style={{
            ...StyleSheet.absoluteFillObject,
            bottom: -100,
            opacity: 0,
          }} />
        </TouchableWithoutFeedback>

        {Object.keys(levelIds).map(level => {
          let levelValues = values.filter(v => levelIds[level].includes(v.id)) //.reverse()
          // console.log(level, levelValues)
          
          let comfinessPerc = 0.7
          let maxCount = SIZE / (100*comfinessPerc)

    // maxCount = 12-(level*2)
          
          if(level == -1) levelValues = new Array(Math.round(maxCount/2)).fill(
            {text: '+', id: 'ftue', selected: true, onPress: () => alert('create'), emptyColor: 'red'}
          )

          // levelValues = levelValues.slice(0,30)
          let canShowMore = false
          if(maxCount < levelValues.length) canShowMore = true
          if(!!this.state[`showMoreLevel${level}`]){
            canShowMore = false
          }
          else {
            levelValues = levelValues.slice(0, maxCount)
          }
          if(canShowMore){
            levelValues.push({text: '...', id: 'ftue', onPress: () => this.setState({[`showMoreLevel${level}`]: true})})
          }

          let levelScaling = level / (topLevel || 1)
          let scalePerc = 1.0 + (2 * (levelScaling))
          // range [1 -> 3]
          let scalePercs = [1, 1.2, 1.6, 3, 5]
          scalePerc = scalePercs[level]
          scalePerc = 1

          let levelScale = 1
          if(applyScaling) levelScale = 0.5 + (2 * levelScaling)

          let wheelStepSize = 0.8 * levelScaling
          // if(applyScaling) wheelStepSize = Math.max(0.05, wheelStepSize*levelScaling)
          if(applyScaling) wheelStepSize = ((wheelStepSize*levelScaling)+wheelStepSize)/2
          // wheelStepSize *= levelScaling
          let wheelScale = 0.95 - (wheelStepSize)
          if(applyScaling){
            // wheelScale = 1 - wheelStepSize
          }
          // range [1 -> 0.3]

          let maxSize = 100 *levelScale
          let fullCanvasSize = topLevel * 250
          maxSize *= Math.min(1, SIZE/fullCanvasSize)
          let minSize = 90 *levelScale
          minSize *= Math.min(1, SIZE/fullCanvasSize)
          let size = maxSize
          let minWrapperSize = (maxSize/2)+(maxSize/8)
          minWrapperSize = ENV.WEB ? maxSize*1.25 : maxSize*1.1
          let gutterSize = (((size/2)*screenRatio)*0.2)*3
          let outterSize = size + (gutterSize)
          let maxOutterSize = outterSize
          if(!ENV.WEB) maxOutterSize = size

          let levelSize = SIZE*wheelScale
            // levelSize = SIZE/2 * wheelScale
            // levelSize /= 2
          let levelOffset = SIZE-levelSize
            // levelOffset = (SIZE/2)-levelSize
            // levelOffset /= 2
          return (
            <TouchableWithoutFeedback 
              key={`level-${level}`}
              onPress={() => {
                this.hoverOut()
                this.setState({quickActionsId: null})
                if(level<0){
                  this.resetRotations()
                }
              }}
            >
            <View
              style={[
                styles.levelWrapper,
                (level == -1) && {borderWidth: 0},
                (level == -1 || applyScaling) && {borderWidth: 0},
                {
                  // right: levelOffset/2,
                  left: levelOffset/2,
                  bottom: levelOffset/2,
                  // right: 0, bottom: 0,
                  width: levelSize,
                  height: levelSize,
                  borderRadius: levelSize/2,
                  transform: [
                    // {scale: wheelScale},
                  ],
                },
              ]} 
            >
              <Wheel 
                // scale={wheelScale}
                size={wheelScale*SIZE}
                disabled={level<0}
                // initialRotation={level%2 ? 0.3 : -0.3}
                // initialRotation={-0.1*(topLevel-level)}
                initialRotation={level == -1 ? -1 : (-0.1*(level+1)* (level%2 ? 1 : -1))}
                // scale={1}
                onPan={gestureState => {
                  // console.log(gestureState.dx)
                }}
                ref={ref => this[`wheel_${level}`] = ref}
              >
                {wheelRot => {
                  // console.log(wheelRot)
                  return (
                    <View style={styles.levelHub}>
                      {levelValues.map((value, i) => (
                        <Hoverable key={i}
                          // onHoverIn={() => this.hoverIn(value)} 
                          // onHoverOut={() => this.hoverOut(value)} 
                        >
                          {isHovered => {
                            if(isHovered) alert('hov')
                            if(!!selectedValue) isHovered = false

                            // let selected = !!selectedValue && selectedValue.id == value.id
                            let selected = familyIds.includes(value.id)
                            
                            // size = (selected || isHovered) ? maxSize : minSize
                            size = maxSize
                            size = isHovered ? maxSize : minSize
                            if(selected) size = Math.max(100, size)

                            gutterSize = (((size/2)*screenRatio)*0.2)*3
                            outterSize = size + (gutterSize)
                            
                            let baseSize = size

                            if(isHovered){
                              console.log('hovering', value)
                              // let scaleFactor = Math.max(1.1, 100/size)
                              // scalePerc = scaleFactor
                            }
                            else {
                              // scalePerc = 1
                            }

                            let wedge = 360/(Math.min(30, levelValues.length+1))
                            wedge = 360/(levelValues.length)
                            // let wedge = 360/(Math.min(30, levelValues.length))
                            let rot = 0
                            rot = 90
                            // rot -= wedge
                            rot -= wedge*i
                            // rot = Math.max(rot, -90-wedge)
                            let invertedRot = rot * -1

                            return (
                              <TouchableWithoutFeedback onPress={() => {
                                this.hoverOut()
                                this.setState({quickActionsId: null})
                              }}>
                              <View
                                style={[
                                  styles.spoke,
                                  {
                                    // left: -size,
                                    minWidth: minWrapperSize,
                                    minHeight: size*1.4,
                                    zIndex: (selected || isHovered) ? 9999 : (levelValues.length-i),
                                  },
                                  // selected || isHovered ? {marginHorizontal: minWrapperSize/2} : null,
                                  {
                                    transform: [
                                      {rotateZ: `${rot}deg`},
                                      level == topLevel && applyScaling ?
                                        {translateY: `25%`} :
                                        {translateY: `50%`},
                                    ],
                                    opacity: !!familyIds.length && !familyIds.includes(value.id) ? 0.2 : 1,
                                  },
                                  level == topLevel && applyScaling && {
                                    top: 0
                                  },
                                ]}
                              >
                                <Animated.View style={{transform: [
                                  { scale: scalePerc },
                                  { rotateZ: wheelRot},
                                ]}}>
                                  <Value 
                                    childrenRing
                                    size={size}
                                    value={value}
                                    key={`value-${value.id}-${consellationKey}`}
                                    ref={(ref) => { this[`val_${value.id}`] = ref }}
                                    // selected={selected || (typeof value.id == 'string' && value.id.includes('ftue'))}
                                    selected={(selectedValue?.id == value.id) || value.selected}
                                    emptyColor={isHovered && value.emptyColor}
                                    onDeselect={() => this.hoverOut(value)}
                                    // onLongPress={() => {
                                    onPress={() => {
                                      if(!!value.onPress){
                                        value.onPress()
                                        return
                                      }
                                      this.setState({lastPressedId: value.id})
                                      // if(ENV.WEB || selected){
                                      if(!!quickActionsId){
                                        this.setState({quickActionsId: null})
                                      }
                                      // else if(true) {
                                      else if(false) {
                                        RootNavigation.push('Value', {id: value.id})
                                      }
                                      else if(!!selectedValue && selectedValue.id == value.id){
                                        RootNavigation.push('Value', {id: value.id})
                                      }
                                      else if(selected){
                                        this.hoverIn(value)
                                      }
                                      else if(!!selectedValue){
                                        this.hoverOut()
                                      }
                                      else {
                                        this.hoverIn(value)
                                      }
                                    }}
                                    style={[{
                                      transform: [
                                        {rotateZ: `${invertedRot}deg`},
                                      ],
                                    }]}
                                    maxWidth={250}
                                    onUpdate={val => this.handleUpdate(val)}
                                    showQuickActions={quickActionsId == value.id}
                                    onShowQuickActions={() => this.setState({quickActionsId: value.id})}
                                    onHideQuickActions={() => this.setState({quickActionsId: null})}
                                    onSelect={ENV.WEB ? () => this.hoverIn(value) : undefined}
                                    showFocusRing={!!showFocus}
                                  />
                                </Animated.View>
                              </View>
                              </TouchableWithoutFeedback>
                            )
                          }}
                        </Hoverable>
                      ))}
                    </View>
                  )
                }}
              </Wheel>
              </View>
            </TouchableWithoutFeedback>
          )
        })}
      </View>
    )
  }

  updateValuesToRender = (values=null) => {
    if(values==null) values = this.state.values
    let valuesToRender = values
    // let valuesToRender = valueHelpers.onlyRecentRevisions(values)
    // if(this.filterBar) valuesToRender = this.filterBar.applyFilters(valuesToRender)
    valuesToRender = filterHelpers.apply(valuesToRender)
    // valuesToRender = valueHelpers.sortByTimeline(valuesToRender)
    this.setState({valuesToRender})
  }

  handleUpdate = async (val, newPrefs=null) => {
    let values = this.state.values.map(v => v.id == val.id ? {...v, ...val} : v)

    values = valueHelpers.sortByTimeline(values)
    storageActions.saveItem('values', values)
    // values = valueHelpers.onlyRecentRevisions(values)
    // if(this.filterBar) values = this.filterBar.applyFilters(values)
    // values = valueHelpers.sortByTimeline(values)
    this.updateValuesToRender(values)
    // values = valueHelpers.applyLevels(values)

    console.log('handleupdate:', val, newPrefs)
    // if(!!newPrefs){
    //   this.setState({...newPrefs})
    // }
    // let pref = await prefActions.get(true)
    // await this.setState({
    //   // values, 
    //   query: '',
    //   hiddenIds: pref.hidden_ids, 
    //   todoIds: pref.todo_ids, 
    //   focusIds: pref.focus_ids, 
    //   // filters: pref.filters, 
    //   query: '',
    // })
    await this.setState({values})
  }

  levelsArray = (values, topLevel) => {
    let { fromBottom } = this.state
    let length = topLevel+1
    let includeNegative = !!values.find(v => v.level < 0)
    includeNegative = true
    if(includeNegative) length += 1
    let levels = new Array(length).fill(0).map((x,i) => includeNegative ? i-1 : i)
    if(fromBottom) levels = levels.reverse()
    // if(REVERSE) levels = levels.reverse()
    return levels
  }

  handleClickValue = value => {
    let { values } = this.state
    value.clicked = true
    values.map(v => v.id == value.id ? value : v)
    this.setState({values})
  }

  hoverIn = async (value) => {
    console.log(value)
    let { values } = this.state
    let familyIds = valueHelpers.getFamily(value).map(v => v.id)
    console.log(valueHelpers.getFamily(value))
    this.setState({familyIds, selectedValue: value, quickActionsId: null})
  }

  hoverOut = (value=null) => {
    this.setState({familyIds: [], selectedValue: null})
  }

  resetRotations = () => {
    let { levelIds } = this.state
    Object.keys(levelIds).forEach(level => {
      if(this.state[`showMoreLevel${level}`]){
        this.setState({[`showMoreLevel${level}`]: false})
      }
      if(this[`wheel_${level}`]){
        this[`wheel_${level}`].resetRotation()
      }
    })
  }
}

// const SIZE = Math.max(WIDTH, HEIGHT)
// const SIZE_CONST = ENV.WEB ? Math.min(WIDTH, HEIGHT) : WIDTH*2
const SIZE_CONST = ENV.WEB ? Math.max(WIDTH, HEIGHT) : WIDTH*2

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'space-around',
    // backgroundColor: '#111',
  },
  headerRow: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingLeft: sizes.base,
    marginBottom: sizes.base,    
  },
  levelWrapper: {
    // flex: 1,
    // ...StyleSheet.absoluteFillObject,
    position: 'absolute',
    bottom: 0,
    right: 0,
    width: SIZE_CONST,
    height: SIZE_CONST,
    borderRadius: SIZE_CONST/2,

    alignItems: 'stretch',
    justifyContent: 'center',
    // borderColor:'white', borderWidth:12,
    borderColor: colors.trim, 
    borderWidth: 2,
    // overflow: 'hidden',
  },
  levelContent: {
    flex: 1,
    alignSelf: 'stretch',
    flexDirection: 'row',
    // justifyContent: 'center',
    // alignItems: 'center',
    // borderWidth: 10, borderColor: 'red',
    position: 'absolute',
    bottom: 0,
    right: 0,
    width: SIZE_CONST,
    height: SIZE_CONST,
  },
  levelHub: {
    position: 'absolute',
    top: '50%',
    top: 0,
    right: '50%',
    width: 0,
    bottom: 0,
    // justifyContent: 'center',
    alignItems: 'center',
    // borderWidth: 10, borderColor: 'blue',
  },
  spoke: {
    flex: 1,
    alignSelf: 'stretch',
    // flexGrow: 0,
    justifyContent: 'flex-end',
    alignSelf: 'center',
    alignItems: 'center',
    // borderColor: 'purple', borderWidth: 2,
    position: 'absolute',
    width: 0,
    // top: '-100%',,
    // bottom: 0,
    top: '25%',
    bottom: '25%',
  },
  queryRow: {
    flexGrow: 0,
    height: 50,
    padding: sizes.base,
    justifyContent: 'flex-start',
  },
  input: {
    ...styleSheet.input,
    alignSelf: 'stretch',
    flex: 1,
  },
  icon: {
    marginLeft: sizes.base,
    minWidth: sizes.base,
    minHeight: sizes.base,
    // borderWidth: 1, borderColor: 'white',
  },
});